















import { Component, Prop, Vue } from "vue-property-decorator";
import Popup from "../popup/popup.vue";
import CzCover from "../cz/CzCover.vue";
import CzTag from "../cz/CzTag.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzChip from "../cz/CzChip.vue";
import CzButton from "../cz/CzButton.vue";

// The whole explanation of a service, opened from "See more" in the listing.
@Component({ components: { Popup, CzCover, CzTag, CzTitle, CzChip, CzButton } })
export default class BookingTypeInfo extends Vue {
  @Prop({ type: String, default: "" }) to!: string;
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) price!: string;
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) goLabel!: string;
}
